import { QuantityCounts } from 'src/app/feature-modules/welcomewizard/quantity-counts';
import {
  RnOrganizationConfigurationVM,
  RnOrganizationsProfileVM,
  RnOrganizationWLPContactInformationVM,
  RnUserTypesVM
} from 'src/app/shared/services/rnapi2-service';

export class AddUserData {
  UserTypes: RnUserTypesVM[] = [];
  ID: number;
  OrgProfile: RnOrganizationsProfileVM;
  OrgConfig: RnOrganizationConfigurationVM;
  OrgWlpContactInfo: RnOrganizationWLPContactInformationVM;
  OwnerActions: QuantityCounts[] = [];
  UserActions: QuantityCounts[] = [];
}
